import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { AdminUserService } from './core/user/admin-user.service';
import { TranslationService } from './modules/i18n';
import { locale as chLang } from './modules/i18n/vocabs/ch';
import { locale as deLang } from './modules/i18n/vocabs/de';
import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as esLang } from './modules/i18n/vocabs/es';
import { locale as frLang } from './modules/i18n/vocabs/fr';
import { locale as jpLang } from './modules/i18n/vocabs/jp';
import { Title } from '@angular/platform-browser';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgSelectConfig } from '@ng-select/ng-select';

// language list
@Component({
  // tslint:disable-next-line:component-selector
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = [];

  constructor(
    private translationService: TranslationService,
    private modeService: ThemeModeService,
    private router: Router,
    private splashScreenService: SplashScreenService,
    private adminUserService: AdminUserService,
    private titleService: Title,
    private localeService: BsLocaleService,
    private ngSelectConfig: NgSelectConfig
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      chLang,
      esLang,
      jpLang,
      deLang,
      frLang
    );

    this.ngSelectConfig.notFoundText = 'Nenhum item encontrado';
    this.ngSelectConfig.loadingText = 'Carregando...';
  }

  ngOnInit() {
    this.localeService.use('pt-br');
    this.modeService.init();

    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scroll(0, 0);

        setTimeout(() => {
          //document.body.classList.add('kt-page--loaded');
        }, 500);
      }
    });

    this.unsubscribe.push(routerSubscription);

    this.unsubscribe.push(
      this.adminUserService.companySubject.subscribe((c) => {
        if (c) {
          this.titleService.setTitle(c.name);
        }
      })
    );
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
